import { Notice } from '../../../Notice/Model/Notice';
import { DashboardRepository } from '../Repositories/DashboardRepository';

export class GetDashboardNoticesUseCase {
  constructor(private repo: DashboardRepository) {}
  execute(): Promise<Notice[]> {
    return this.repo.getRecentNotices().then(r => r).catch(err => Promise.reject(err));
  }
}
